import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { ReflectionsComponent } from './reflections/reflections.component';
import { ReportComponent } from '../shared/components/report/report.component';

export const shellRoutes: Routes = [
    { path: 'reflections', component: ReflectionsComponent, canActivate: [MsalGuard] },
    { path: 'reflections/:id/report', component: ReportComponent, canActivate: [MsalGuard] },
    { path: 'reflections/:id/compare/:id2', component: ReportComponent, canActivate: [MsalGuard] },
];

const fullScreenRoutes: Routes = [{ path: 'reflections/:id/report/print', component: ReportComponent, canActivate: [MsalGuard] }];

@NgModule({
    imports: [RouterModule.forChild(fullScreenRoutes)],
    exports: [RouterModule],
})
export class ReflectionsRoutingModule { }
